import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
// import moment from 'moment'
import { Query, withApollo } from 'react-apollo'
import { withRouter } from 'react-router'
import MUIDataTable from 'mui-datatables'
import {
  TableHead,
  TableRow,
  TableBody,
  Table,
  TableCell,
  Paper,
  Grid,
  TablePagination,
  Button,
  withStyles
} from '@material-ui/core'
import Loader from '../../../components/common/Loader'

const GET_ALL_PARTNER_SUBSCRIPTION = gql`
  query getAllPartnerSubscriptions($partnerLoginId: Int) {
    getAllPartnerSubscriptions(partnerLoginId: $partnerLoginId) {
      id
      partnerLoginId
      status
      gst
      amount
      totalDeviceQty
      unassignedDeviceQuantity
      billingFrequencyId
      hardwareCharges
      totalSoftwareQty
      unbilledSoftware
      totalSoftwareQty
      unbilledSoftware
      noOfDevices
      deviceTrackingCharges
      simQty
      unbilledSims
      unassignedSimQty
      unassignedSimQty
      simCharges
      accessoryQty
      unbilledAccessory
      unassignedAccessoryQty
      unbilledDeviceQty
      nextPaymentDate
      accessoryCharges
      unassignedAccessoryQty
      partnerDetail {
        id
        businessName
      }
      billingMode {
        id
        billingMode
      }
      billingFrequency {
        id
        frequency
        numberOfMonths
      }
      deviceModel {
        model_name
      }
      serviceProvider{
        name
      }
    }
  }
`

const styles = {
  tableRow: {
    cursor: 'pointer',

    '&:hover': {
      background: 'rgb(245, 245, 245)'
    }
  }
}

// class SubscriptionsTable extends Component {
//   state = {
//     page: 0,
//     rowsPerPage: 5
//   }

//   handleChangePage = (event, newPage) => {
//     this.setState({ page: newPage })
//   }

//   handleChangeRowsPerPage = event => {
//     this.setState({ rowsPerPage: +event.target.value })
//   }

//   handleEdit = subscription => {
//     this.props.history.push(
//       this.props.location.pathname + '/edit-subscription',
//       {
//         edit: true,
//         subscriptionDetails: {
//           id: subscription.subscriptionId,
//           selectedBillingMode: subscription.billingMode.id,
//           selectedBillingFrequency: subscription.billingFrequency.id,
//           deviceQuantity: subscription.noOfDevices,
//           deviceRate: subscription.mmtc,
//           gst: subscription.gst
//         }
//       }
//     )
//   }

//   render() {
//     const { rows, classes } = this.props
//     const { page, rowsPerPage } = this.state

//     return (
//       <Fragment>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell>Billing Mode</TableCell>
//               <TableCell>Billing Frequency</TableCell>
//               <TableCell>Device Quantity</TableCell>
//               <TableCell>MMTC</TableCell>
//               <TableCell>GST</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {rows
//               .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//               .map(subscription => (
//                 <TableRow
//                   key={subscription.subscriptionId}
//                   onClick={() => this.handleEdit(subscription)}
//                   className={classes.tableRow}
//                 >
//                   <TableCell>{subscription.billingMode.billingMode}</TableCell>
//                   <TableCell>
//                     {subscription.billingFrequency.frequency}
//                   </TableCell>
//                   <TableCell>{subscription.noOfDevices}</TableCell>
//                   <TableCell>{subscription.mmtc}</TableCell>
//                   <TableCell>{subscription.gst}</TableCell>
//                   {/* <TableCell>
//                     {moment
//                       .unix(subscription.nextPaymentDate)
//                       .format('MMM Do YYYY')}
//                   </TableCell> */}
//                 </TableRow>
//               ))}
//           </TableBody>
//         </Table>

//         <TablePagination
//           rowsPerPageOptions={[5, 10, 25]}
//           component="div"
//           count={rows.length}
//           rowsPerPage={rowsPerPage}
//           page={page}
//           backIconButtonProps={{
//             'aria-label': 'Previous Page'
//           }}
//           nextIconButtonProps={{
//             'aria-label': 'Next Page'
//           }}
//           onChangePage={this.handleChangePage}
//           onChangeRowsPerPage={this.handleChangeRowsPerPage}
//         />
//       </Fragment>
//     )
//   }
// }

// const WrappedSubscriptionsTable = withStyles(styles)(SubscriptionsTable)
// const SubscriptionsQuery = props => {
//   return (
//     <Query
//       query={GET_SUBSCRIPTIONS}
//       variables={{
//         partnerLoginId: props.partnerLoginId
//       }}
//       fetchPolicy="cache-and-network"
//     >
//       {({ loading, error, data }) => {
//         if (loading) return <Loader />

//         if (error) return 'Error'

//         const rows = data.subscriptions

//         return (
//           <WrappedSubscriptionsTable
//             rows={rows}
//             location={props.location}
//             history={props.history}
//           />
//         )
//       }}
//     </Query>
//   )
// }

class Subscriptions extends Component {
  constructor(props) {
    super(props)
    this.partnerLoginId = parseInt(this.props.match.params.loginId, 10)
    this.state = {
      getAllPartnerSubcriptionsData: [],
      subscriptionTableData: []
    }
  }

  subscriptionIdArray = []

  columns = [
    'MODEL',
    'SERVICE PROVIDER',
    'DEVICE COUNT',
    'BILLING MODE',
    'BILLING FREQUENCY',
    'MMTC',
    'STATUS'
  ]

  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      this.props.history.push({
        pathname:
          '/home/partner/view' +
          '/' +
          this.props.partnerLoginId +
          '/' +
          this.subscriptionIdArray[dataIndex.dataIndex] +
          '/subscriptionDetail'
      })
    }
  }

  handleNewSubscriptionClick = () => {
    // console.log('hi', this.props.location.pathname)
    this.props.history.push({
      pathname: this.props.location.pathname + '/add-subscription'
    })
  }

  mapToArray = allSubscriptionData => {
    const mappedSubscription = allSubscriptionData.reduce(
      (acc, subscription) => {
        const rowData = []
        this.subscriptionIdArray.push(parseInt(subscription.id, 10))
        rowData.push(subscription.deviceModel.model_name)
        if (subscription.serviceProvider===null ||subscription.serviceProvider===undefined ){
          rowData.push('NA')
         } else {
           rowData.push(subscription.serviceProvider.name)
         }
        rowData.push(parseInt(subscription.totalDeviceQty, 10))
        rowData.push(subscription.billingMode.billingMode)
        rowData.push(subscription.billingFrequency.frequency)
        rowData.push(parseInt(subscription.deviceTrackingCharges, 10))
        console.log('status', subscription.status)
        if (subscription.status === 1 || subscription.status === 4) {
          rowData.push('Pending')
        } else if (subscription.status === 2 || subscription.status === 5) {
          rowData.push('Approved')
        } else if (subscription.status === 3) {
          rowData.push('Rejected')
        }
        acc.push(rowData)
        return acc
      },
      []
    )
    this.setState({ subscriptionTableData: mappedSubscription })
    // console.log('mapped data', mappedSubscription)
    // console.log('subscriptio arr', this.subscriptionIdArray)
  }

  getAllPartnerSubcriptions = async () => {
    const { data } = await this.props.client.query({
      query: GET_ALL_PARTNER_SUBSCRIPTION,
      variables: {
        partnerLoginId: this.partnerLoginId
      },
      fetchPolicy: 'network-only'
    })
    console.log(
      ' data.getAllPartnerSubscriptions',
      data.getAllPartnerSubscriptions
    )
    if (data && data.getAllPartnerSubscriptions) {
      this.setState(
        {
          getAllPartnerSubcriptionsData: data.getAllPartnerSubscriptions
        },
        () => {
          this.mapToArray(this.state.getAllPartnerSubcriptionsData)
        }
      )
    }
  }

  componentDidMount = () => {
    this.getAllPartnerSubcriptions()
  }

  render() {
    const { subscriptionTableData } = this.state
    return (
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <Grid container justify="flex-end">
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                onClick={this.handleNewSubscriptionClick}
              >
                Create Subscription
              </Button>
            </Grid>
          </Grid>
        </Grid>

        {/* Display Subsctiption Table */}
        <Grid item xs={12}>
          <Paper>
            <MUIDataTable
              data={subscriptionTableData}
              columns={this.columns}
              options={this.options}
            />
            {/* <SubscriptionsQuery
              partnerLoginId={props.partnerLoginId}
              history={props.history}
              location={props.location}
            /> */}
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(withApollo(withRouter(Subscriptions)))



// WEBPACK FOOTER //
// ./src/components/Pages/Partner/Subscriptions.jsx